import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderPochtaCourierAddressDto
*  Адрес доставки до двери.
*/
export class OrderPochtaCourierAddressDto extends ActiveModel {

/**
  * postalCode
  * Почтовый индекс.
  */
  @ActiveField('')
  postalCode: string = ''


/**
  * city
  * Город / населённый пункт.
  */
  @ActiveField('')
  city: string = ''


/**
  * street
  * Улица.
  */
  @ActiveField('')
  street: string = ''


/**
  * house
  * Дом/строение.
  */
  @ActiveField('')
  house: string = ''


/**
  * apartment
  * Квартира / офис; опционально.
  */
  @ActiveField()
  apartment?: null | string


/**
  * region
  * Регион (субъект РФ); опционально, например из PostofficeByIndex.
  */
  @ActiveField()
  region?: null | string
}
